import request from './index';
import {
  IExecutionProgressStatusResponse,
  IExecutionProgressStatusesResponse,
  IPatchExecutionProgressStatusRequest,
  IPostExecutionProgressStatusRequest
} from 'types/forms/executionProgressStatuses';

export const getExecutionProgressStatuses = (taskId: number | string) =>
  request<IExecutionProgressStatusesResponse>({
    options: {
      url: `/tasks/${taskId}/execution_progress_statuses`,
      method: 'get'
    }
  });

export const postExecutionProgressStatus = (
  taskId: number | string,
  data: IPostExecutionProgressStatusRequest
) =>
  request<IExecutionProgressStatusResponse>({
    options: {
      url: `/tasks/${taskId}/execution_progress_statuses`,
      method: 'post',
      data
    }
  });

export const patchExecutionProgressStatus = (
  taskId: number | string,
  id: number | string,
  data: IPatchExecutionProgressStatusRequest
) =>
  request<IExecutionProgressStatusResponse>({
    options: {
      url: `/tasks/${taskId}/execution_progress_statuses/${id}`,
      method: 'patch',
      data
    }
  });

export const deleteExecutionProgressStatus = (
  taskId: number | string,
  id: number | string
) =>
  request({
    options: {
      url: `/tasks/${taskId}/execution_progress_statuses/${id}`,
      method: 'delete'
    }
  });
